<template>
  <!-- Modale informativa con le info sugli acquisti effettuati per i parenti e per indicare che si tratta di acquisti -->
  <!-- che intaccano il monte buoni da visualizzare prima di far continuare l'utente -->
  <b-modal v-model="conditions_modal" title="Comunicazione" class="text-justify" size="xl"
          no-close-on-esc
          no-close-on-backdrop
          scrollable
          hide-header-close
          hide-footer>
    <!-- Non è ben chiaro se questa parte debba essere rimossa, nel dubbio al momento la commentiamo senza cancellarla -->
    <!--<b-row>
      <b-col class="alert alert-warning mr-2 ml-2" role="alert">
          <h5><b-icon icon="exclamation-triangle"></b-icon> IMPORTANTE:</h5>
          <ul>
          <li>gli acquisti effettuati in questa sezione <b>verranno scalati dal credito relativo ai buoni (art51c3)</b> attualmente pari a: {{$store.state.user.user_credito.art51c3}} €</li>
          <li>nel rispetto degli artt. 51 e 100 del Testo Unico Imposte sui Redditi, il beneficiario del Piano Welfare può effettuare acquisti
             tramite la piattaforma web nella presente sezione solo per sé o per i familiari indicati nell'art.433 del Codice Civile vigente, richiamato dall'art.
             12 del Testo Unico Imposte sui Redditi.</li>
          </ul>
      </b-col>
    </b-row>-->
    <b-row>
      <b-col>
          <p class="alert-message p-2"><b>ATTENZIONE!</b> Esplora attentamente tutte le possibilità di scelta offerte dalla sezione "buoni", ma ricorda che una volta inviata la richiesta d'acquisto di un prodotto/buono specifico, essa non potrà essere annullata.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
          <b-form>
            <b-form-group id="group-ok-condizioni">
                <b-form-checkbox
                id="ok-condizioni"
                name="ok-condizioni"
                :value="true"
                :unchecked-value="false"
                v-model="conditions_checkbox"
                required>
                <span class="font-italic">Confermo di voler accedere al portale ExAnte Mutua e di essere consapevole che i buoni opzionati non potranno essere annullati.</span>
                </b-form-checkbox>
            </b-form-group>
            <b-button v-if="show_modal_ok_btn" variant="primary" class="mr-2" @click="$store.commit( 'set_eurete_cond_agreement', true );">Continua</b-button>
            <b-button variant="warning" :to="{ name : 'menu' }">Torna alla home</b-button>
          </b-form>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'DiscalimerCondizioni',
  data () {
    return {
      // Checkbox per l'accettazione delle condizioni.
      conditions_checkbox : false
    }
  },
  computed : {
    /**
     * Condizione di visualizzazione della modale.
     * Se l'utente ha accettato per questa sessione le condizioni ( variabile di
     * sessione "eurete_cond_agreed' nello store a true ), allora la modale viene
     * nascosta, altrimenti viene mostrata.
     */
    conditions_modal : function () {
      return this.$store.state.session_infos.eurete_cond_agreed === true ? false : true;
    },
    /**
     * Se l'utente ha accettato le condizioni nel disclaimer tramite
     * la checkbox, allora visualizza il pulsante di ok per continuare.
     */
    show_modal_ok_btn : function () {
      return this.conditions_checkbox === true ? true : false;
    }
  }
}
</script>

<style scoped>
.alert-message{
  color: #721c24;
  background-color: #f8d7da;
}
</style>